import { useEffect, useMemo, useRef, useState } from 'react'
import styles from './TipologiesSelect.module.scss'

export default function TipologiesSelect({
	lang,
	textos,
	canonics,
	canonicsSeleccionats,
	totsSeleccionats,
	configuracioTipologies,
	onReset,
	onToggle,
}) {
	const containerRef = useRef(null)
	const [obert, setObert] = useState(false)

	const getNomCanonic = (canonic) => configuracioTipologies?.[canonic]?.nom || canonic

	const resumTipologies = useMemo(() => {
		if (totsSeleccionats) {
			return textos[lang]?.tots || 'Totes'
		}

		if (canonicsSeleccionats.length === 0) {
			return textos[lang]?.selecciona_tipologia || 'Selecciona tipologies'
		}

		if (canonicsSeleccionats.length === 1) {
			return getNomCanonic(canonicsSeleccionats[0])
		}

		return `${canonicsSeleccionats.length} ${textos[lang]?.tipologies_seleccionades || 'tipologies seleccionades'}`
	}, [canonicsSeleccionats, lang, textos, totsSeleccionats])

	useEffect(() => {
		const handleClickFora = (event) => {
			if (!containerRef.current?.contains(event.target)) {
				setObert(false)
			}
		}

		const handleEscape = (event) => {
			if (event.key === 'Escape') {
				setObert(false)
			}
		}

		document.addEventListener('pointerdown', handleClickFora)
		document.addEventListener('keydown', handleEscape)

		return () => {
			document.removeEventListener('pointerdown', handleClickFora)
			document.removeEventListener('keydown', handleEscape)
		}
	}, [])

	return (
		<div className={`${styles.multiSelect} ${obert ? styles.obert : ''}`} ref={containerRef}>
			<button
				type='button'
				className={styles.trigger}
				onClick={() => setObert((actual) => !actual)}
				aria-haspopup='listbox'
				aria-expanded={obert}
			>
				<span>{resumTipologies}</span>

				<svg
					className={styles.icon}
					aria-hidden='true'
					width='18'
					height='18'
					viewBox='0 0 18 18'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'
				>
					<g clipPath='url(#clip0_2974_1556)'>
						<path
							d='M12.4425 6.44238L9 9.87738L5.5575 6.44238L4.5 7.49988L9 11.9999L13.5 7.49988L12.4425 6.44238Z'
							fill='black'
						/>
					</g>
					<defs>
						<clipPath id='clip0_2974_1556' clipPathUnits='userSpaceOnUse'>
							<rect width='18' height='18' fill='white' />
						</clipPath>
					</defs>
				</svg>
			</button>
			<div className={styles.options} role='listbox' aria-multiselectable='true'>
				<label className={styles.opcio} role='option' aria-selected={totsSeleccionats}>
					<input type='checkbox' checked={totsSeleccionats} onChange={onReset} />
					<span>{textos[lang]?.tots || 'Totes'}</span>
				</label>
				{canonics.map((canonic) => {
					const seleccionat = canonicsSeleccionats.includes(canonic)

					return (
						<label key={canonic} className={styles.opcio} role='option' aria-selected={seleccionat}>
							<input type='checkbox' checked={seleccionat} onChange={() => onToggle(canonic)} />
							<span>{getNomCanonic(canonic)}</span>
						</label>
					)
				})}
			</div>
		</div>
	)
}
